export enum PaymentProvider {
  NONE = "NONE",
  PIQ = "PIQ",
  FILUET = "FILUET",
  GATEWAY = "GATEWAY",
}
